import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/for-dealers/")({
  head: () => routeHead("/uk/for-dealers/"),
  beforeLoad: () => {
    throw redirect({ href: "/dealeri", statusCode: 301, replace: true });
  },
});
